import './Boost.css'; // Import CSS file for styling
import React from 'react';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

function Info() {
  return (
    <div className="boost-container3">
      <h1 className="large-text4">
        <TranslateText text="HOW DO OUR TRADELINE PACKAGES WORK?" />
      </h1>
      <div className='separator'></div>
      <br />
      <span className="large-text">
        <TranslateText text="All of our packages are truly unique and powerful because they are custom built using the" />
      </span>
      <span className="large-text">
        <TranslateText text="proprietary “Age Progressional” method. Its a hand-selected package of tradelines prescribed to" />
      </span>
      <span className="large-text">
        <TranslateText text="offset the weaknesses in your credit score, which in turn, increases your credit score. The oldest" />
      </span>
      <span className="large-text">
        <TranslateText text="tradeline is a lower credit limit, and the newer tradelines are higher credit limits. This is" />
      </span>
      <span className="large-text">
        <TranslateText text="to show that your credit has gotten better over time. Age Progressional Tradeline Packages" />
      </span>
      <span className="large-text">
        <TranslateText text="are selected from the same cardholder, or two cardholders max, to ensure the addresses are" />
      </span>
      <span className="large-text">
        <TranslateText text="kept to a minimum. This also ensures easy, breezy posting to your credit report." />
      </span>
    </div>
  );
}

export default Info;



// import './Boost.css'; // Import CSS file for styling
// import React from 'react';

// function Info() {

//   return (
//     <div className="boost-container3">
//       <h1 className="large-text4">HOW DO OUR TRADELINE PACKAGES WORK?</h1>
//       <div className='separator'></div>
//       <br />
//       <span className="large-text">All of our packages are truly unique and powerful because they are custom built using the</span>
//       <span className="large-text">proprietary “Age Progressional” method. Its a hand-selected package of tradelines prescribed to</span>
//       <span className="large-text">offset the weaknesses in your credit score, which in turn, increases your credit score. The oldest</span>
//       <span className="large-text">tradeline is a lower credit limit, and the newer tradelines are higher credit limits. This is</span>
//       <span className="large-text">to show that your credit has gotten better over time. Age Progressional Tradeline Packages</span>
//       <span className="large-text">are selected from the same cardholder, or two cardholders max, to ensure the addresses are</span>
//       <span className="large-text">kept to a minimum. This also ensures easy, breezy posting to your credit report.</span>
//     </div>
//   );
// }

// export default Info;


// // import './Boost.css'; // Import CSS file for styling

// // import React, { useEffect } from 'react';

// // function Info() {
 
// //   return (
// //     <div className="boost-container3">
// //       <h1 className="large-text4">HOW DO OUR TRADELINE PACKAGES WORK?</h1>
// //       <div className='separator'></div>
// //             <br></br>

// //       <span className="large-text">All of our packages are truly unique and powerful because they are custom built using the </span>
// //       <span className="large-text">proprietary “Age Progressional” method.It’s a hand-selected package of tradelines prescribed to </span>
// //       <span className="large-text">offset the weaknesses in your credit score, which in turn, increases your credit score. The oldest </span>
// //       <span className="large-text"> tradeline is a lower credit limit, and the newer tradelines are higher credit limits. This is </span>
// //       <span className="large-text">  to show that your credit has gotten better over time. Age Progressional Tradeline Packages</span>
// //       <span className="large-text">  are selected from the same cardholder, or two cardholders max, to ensure the addresses are </span>
// //       <span className="large-text"> kept to a minimum. This also ensures easy, breezy posting to your credit report.</span>


// //     </div>
// //   );
// // }

// // export default Info;
